import { LegalHeader } from "./Impressum";
import { Footer } from "../components/Footer";
import { COMPANY } from "../constants";

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-heading text-xl sm:text-2xl font-medium text-ink mb-3">{title}</h2>
    <div className="text-sm sm:text-base space-y-3">{children}</div>
  </section>
);

export default function Datenschutz() {
  return (
    <>
      <LegalHeader />
      <main className="bg-white py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8" data-testid="datenschutz-page">
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-ink">
            Datenschutzerklärung
          </h1>
          <p className="mt-4 text-sm text-mutedtext">Stand: Oktober 2026</p>

          <div className="mt-10 space-y-9 text-mutedtext leading-relaxed">
            <Section title="1. Verantwortlicher">
              <p>
                Verantwortlicher für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p>
                {COMPANY.name}
                <br />
                Inhaber: {COMPANY.owner}
                <br />
                {COMPANY.street}, {COMPANY.city}, Deutschland
                <br />
                Telefon: {COMPANY.phoneIntl}
                <br />
                E-Mail: {COMPANY.email}
              </p>
            </Section>

            <Section title="2. Hosting und Server-Logfiles">
              <p>
                Diese Website wird bei einem externen Hosting-Dienstleister betrieben. Beim Aufruf
                der Website werden durch den Hosting-Anbieter automatisch Informationen in
                sogenannten Server-Logfiles erfasst (z.&nbsp;B. IP-Adresse, Datum und Uhrzeit des
                Zugriffs, aufgerufene Seite, Browsertyp und Betriebssystem). Die Verarbeitung
                erfolgt auf Grundlage von Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO (berechtigtes
                Interesse an einem sicheren und stabilen Betrieb der Website). Eine Zusammenführung
                dieser Daten mit anderen Datenquellen findet nicht statt.
              </p>
            </Section>

            <Section title="3. Kontakt- und Rückrufformular">
              <p>
                Wenn Sie uns über das Kontaktformular eine Anfrage senden oder über das
                Rückruf-Formular einen Rückruf anfordern, verarbeiten wir die von Ihnen angegebenen
                Daten (bei der Anfrage: Unternehmen, Ansprechpartner, Telefonnummer, E-Mail-Adresse,
                Angaben zum Objekt sowie Ihre Nachricht; beim Rückrufwunsch: Name, Telefonnummer,
                Wunschzeitraum sowie Ihre Nachricht) ausschließlich zur Bearbeitung Ihrer
                Anfrage, zur Vereinbarung einer kostenlosen Objektbesichtigung oder zur Durchführung
                des Rückrufs.
              </p>
              <p>
                Ihre Angaben werden auf dem Server gespeichert und zusätzlich per E-Mail über einen
                E-Mail-Dienstleister an uns übermittelt. Rechtsgrundlage ist Art.&nbsp;6
                Abs.&nbsp;1 lit.&nbsp;b DSGVO (vorvertragliche Maßnahmen) sowie Ihre Einwilligung
                gemäß Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a DSGVO, die Sie durch das Setzen des
                entsprechenden Hakens erteilen. Sie können diese Einwilligung jederzeit mit Wirkung
                für die Zukunft widerrufen. Die Daten werden gelöscht, sobald sie für die
                Bearbeitung Ihrer Anfrage nicht mehr erforderlich sind und keine gesetzlichen
                Aufbewahrungspflichten bestehen.
              </p>
            </Section>

            <Section title="4. Kontakt per E-Mail oder Telefon">
              <p>
                Bei Kontaktaufnahme per E-Mail oder Telefon verarbeiten wir Ihre Angaben zur
                Bearbeitung der Anfrage auf Grundlage von Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b
                DSGVO. Die Daten werden gelöscht, sobald die Anfrage abschließend bearbeitet ist
                und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
              </p>
            </Section>

            <Section title="5. Verlinkungen zu Drittanbietern (WhatsApp, Google Maps)">
              <p>
                Auf dieser Website sind Links zu WhatsApp (WhatsApp Ireland Limited, einem Unternehmen
                der Meta-Gruppe) sowie zu Google Maps (Google Ireland Limited) eingebunden. Es handelt
                sich um einfache Verlinkungen; erst wenn Sie aktiv auf einen dieser Links klicken,
                verlassen Sie unsere Website und es gelten die Datenschutzbestimmungen des jeweiligen
                Anbieters. Dabei werden personenbezogene Daten (z.&nbsp;B. Ihre Telefonnummer und
                Metadaten der Kommunikation) durch WhatsApp verarbeitet; eine Datenübertragung in
                Drittländer kann nicht ausgeschlossen werden. Wir haben auf die Datenverarbeitung durch
                diese Anbieter keinen Einfluss.
              </p>
            </Section>

            <Section title="6. Schriftarten (Google Fonts)">
              <p>
                Zur einheitlichen Darstellung dieser Website werden Schriftarten von Google Fonts
                (Google Ireland Limited) eingebunden. Beim Aufruf der Seite stellt Ihr Browser
                eine Verbindung zu den Servern von Google her, um die Schriftdateien zu laden;
                dabei wird insbesondere Ihre IP-Adresse an Google übermittelt. Die Nutzung erfolgt
                auf Grundlage von Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO (berechtigtes Interesse
                an einer einheitlichen und ansprechenden Darstellung der Website).
              </p>
            </Section>

            <Section title="7. Einwilligungsverwaltung (Cookie-Consent)">
              <p>
                Wenn Sie unsere Website zum ersten Mal besuchen, wird Ihnen ein
                Einwilligungs-Hinweis (Consent-Banner) angezeigt. Dort können Sie wählen, ob Sie
                Marketing-Dienste (Google Ads Conversion-Tracking) zulassen möchten („Alle
                akzeptieren"), ablehnen oder über „Einstellungen" eine individuelle Auswahl
                treffen. Ihre Entscheidung wird ausschließlich lokal in Ihrem Browser (Local
                Storage) gespeichert; hierfür wird kein Cookie gesetzt. Analyse- und
                Tracking-Dienste ohne Einwilligung setzen wir nicht ein.
              </p>
              <p>
                Sie können Ihre Auswahl jederzeit mit Wirkung für die Zukunft über den Link
                „Cookie-Einstellungen" im Footer dieser Website ändern oder widerrufen.
              </p>
            </Section>

            <Section title="8. Google Ads Conversion-Tracking">
              <p>
                Diese Website verwendet mit Ihrer Einwilligung das Conversion-Tracking von Google
                Ads, einem Dienst der Google Ireland Limited, Gordon House, Barrow Street,
                Dublin&nbsp;4, Irland („Google"). Rechtsgrundlage ist Ihre Einwilligung gemäß
                Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a DSGVO.
              </p>
              <p>
                Über den Google-Tag (Conversion-ID AW-18510592406) wird gemessen, ob Besucherinnen
                und Besucher nach einem Klick auf eine unserer Google-Anzeigen eine Anfrage über
                unser Kontaktformular senden. Erst nach Ihrer Einwilligung werden entsprechende
                Marketing-Cookies gesetzt und Informationen (z.&nbsp;B. IP-Adresse, aufgerufene
                Seiten, Formularereignisse) an Google übertragen. Über den „Google Consent Mode"
                wird Ihre Entscheidung an Google signalisiert; ohne Einwilligung erfolgt die
                Übermittlung ausschließlich in reduzierter, cookieloser Form, die keiner Person
                zugeordnet werden kann.
              </p>
              <p>
                Google verarbeitet diese Daten zur Erfolgsmessung unserer Werbemaßnahmen. Dabei kann
                es zu einer Übertragung von Daten an Server von Google in den USA kommen; Google ist
                unter dem EU-US Data Privacy Framework zertifiziert. Sie können Ihre Einwilligung
                jederzeit mit Wirkung für die Zukunft über den Link „Cookie-Einstellungen" im Footer
                widerrufen. Weitere Informationen finden Sie in der{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand underline underline-offset-2"
                >
                  Datenschutzerklärung von Google
                </a>
                .
              </p>
            </Section>

            <Section title="9. SSL- bzw. TLS-Verschlüsselung">
              <p>
                Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung.
                Daten, die Sie an uns übermitteln, können dadurch nicht von Dritten mitgelesen
                werden.
              </p>
            </Section>

            <Section title="10. Ihre Rechte">
              <p>
                Sie haben im Rahmen der gesetzlichen Bestimmungen jederzeit das Recht auf
                unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten (Art.&nbsp;15
                DSGVO), deren Berichtigung (Art.&nbsp;16 DSGVO), Löschung (Art.&nbsp;17 DSGVO),
                Einschränkung der Verarbeitung (Art.&nbsp;18 DSGVO), Datenübertragbarkeit
                (Art.&nbsp;20 DSGVO) sowie ein Widerspruchsrecht (Art.&nbsp;21 DSGVO). Erteilte
                Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft widerrufen
                (Art.&nbsp;7 Abs.&nbsp;3 DSGVO). Wenden Sie sich hierzu einfach an die oben
                genannten Kontaktdaten.
              </p>
            </Section>

            <Section title="11. Beschwerderecht bei der Aufsichtsbehörde">
              <p>
                Im Falle datenschutzrechtlicher Verstöße steht Ihnen ein Beschwerderecht bei der
                zuständigen Aufsichtsbehörde zu (Art.&nbsp;77 DSGVO). Zuständig ist die
                Landesbeauftragte für den Datenschutz Niedersachsen.
              </p>
            </Section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
